const CONTROLLER = "/utils";
const PATHS = {
  GET_JOB_SUBJECTS: "/job/subjects",
  GET_ACCOUNT_TYPES: "/account-types",
  GET_LEAGUE: "/leagues",
  GET_SUBSCRIPTION_PLANS: "/subscription-plans",
};

export const UtilsApiRoutes = {
  CONTROLLER,
  PATHS,
  GET_JOB_SUBJECTS: `${CONTROLLER}${PATHS.GET_JOB_SUBJECTS}`,
  GET_ACCOUNT_TYPES: `${CONTROLLER}${PATHS.GET_ACCOUNT_TYPES}`,
  GET_LEAGUE: (leagueId: string) => `${CONTROLLER}${PATHS.GET_LEAGUE}/${leagueId}`,
  GET_SUBSCRIPTION_PLANS: `${CONTROLLER}${PATHS.GET_SUBSCRIPTION_PLANS}`,
};
